export const saleActive = (p) =>
  !!p && p.sale_price > 0 && p.sale_price < p.price &&
  (!p.sale_ends_at || new Date(p.sale_ends_at) > new Date());

export const effectivePrice = (p) => (saleActive(p) ? p.sale_price : p?.price);

export const salePct = (p) => (saleActive(p) ? 1 - p.sale_price / p.price : 0);

export const variantEffectivePrice = (p, v) => {
  if (!v) return undefined;
  const f = salePct(p);
  return f ? +(v.price * (1 - f)).toFixed(2) : v.price;
};

export const discountedStartingPrice = (p) => {
  const f = salePct(p);
  return f && p.starting_price > 0 ? +(p.starting_price * (1 - f)).toFixed(2) : p.starting_price;
};
